import { render } from "./originContents.vue?vue&type=template&id=65793cfc&scoped=true"
import script from "./originContents.vue?vue&type=script&lang=js"
export * from "./originContents.vue?vue&type=script&lang=js"

import "./originContents.vue?vue&type=style&index=0&id=65793cfc&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65793cfc"]])

export default __exports__